/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceRestrictionCheckQuery$variables = {
  spaceKey: string;
};
export type SpaceRestrictionCheckQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
  } | null;
};
export type SpaceRestrictionCheckQuery = {
  response: SpaceRestrictionCheckQuery$data;
  variables: SpaceRestrictionCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "routeOverrideEnabled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceRestrictionCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceRestrictionCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8899b56f857af5bbb6a7740a976421fb",
    "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
    "metadata": {},
    "name": "SpaceRestrictionCheckQuery",
    "operationKind": "query",
    "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
  }
};
})();

(node as any).hash = "57291753cf0096ea57a2f2351520a494";

export default node;
